import AuthComponent from '../components/auth/AuthComponent';

if (document.getElementById('auth-component')) {
  new Vue({
    el: '#auth-component',
    components: {
      AuthComponent
    },
  });
}

